
import React, { useEffect } from 'react';
import { Spin } from 'antd';
import moment from 'moment';

import CustomerReviews from '../../shared/CustomerReviews';
import WebsiteBenefits from '../../shared/WebsiteBenefits';
import FeaturedCampaigns from '../../shared/FeaturedCampaigns';

import AllCategoriesSection from './AllCategoriesSection';

const CategoryListings = (props) => {
  const {
    history,
    categoryListings,
    getCustomerReviews,
    getPledgeOfTheDay,
    getCategories,
    getFeaturedCampaigns
  } = props;

  const {
    customerReviews,
    loading,
    categories,
    pledgeOfTheDay,
    featuredCampaigns
  } = categoryListings;

  const { data } = featuredCampaigns || {};
  let pledge = {};
  if (pledgeOfTheDay && pledgeOfTheDay.length) {
    pledge = pledgeOfTheDay[0];
  }
  const { title, story, amount, progress, cover_photo: coverPhoto, end_date, deadline, address } = pledge || {};
  const cover = coverPhoto ? `${process.env.REACT_APP_BACKEND_BASE_URL}/${coverPhoto}` : '/images/pledge-of-the-day.png';
  const daysGone = deadline ? `${Math.abs(moment(deadline).diff(moment(), 'days'))} days left` : 'N/A';
  const formattedAddress = address ? (address.length >= 35 ? `${address.substring(0, 30)}...` : address) : 'N/A';

  useEffect(() => {
    getPledgeOfTheDay();
    getCategories();
    getFeaturedCampaigns();
    getCustomerReviews();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  
  return (
    <div>
      <section className="banner choise-banner">
        <div className="container">
          <div className="row  ">
            <div className="col-lg-6 col-md-8 col-sm-12">
              <h1>Raise funds for those<span className="d-block"> you care about</span> </h1>
              <p className="">Our vision is for a world where no one is needlessly blind, and Indigenous Australians enjoy the same health and life expectancy as other Australians.</p>
              <button onClick={() => history.push('/auth/login')} type="button" className="btn btn-outline-light ">Donate now</button>
              <button onClick={() => history.push('/starting_fund')} type="button" className="btn btn-success  ml-2 btn_hover">Start fundraising</button>
            </div>
          </div>
        </div>
      </section>
      <Spin spinning={loading}>

        <section className="choose-a-fundraiser">
          <div className="container">
            <div className="row d-flex align-items-center justify-content-center text-center">
              <div className="col-lg-4 col-md-4 col-sm-6 border-rigt banner-bottom">
                <h4>1. Choose a Fundraiser</h4>
                <p>Browse our fundraising ideas for inspiration</p>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 border-rigt banner-bottom">
                <h4>2. Create a Campaign</h4>
                <p>Simply sign up with your email or facebook to get started</p>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 banner-bottom">
                <h4>3. Invite your Friends</h4>
                <p>Send out your unique link to start receving donations</p>
              </div>
            </div>
          </div>
        </section>

        <section className='donate-section choise-sec-3'>
          <div className='container'>
            <div className='row align-items-center justify-content-center'>
              <div className='col-lg-7 col-md-12 pl-md-5 custom-text-width'>
                <h3 className="main-heading mt-4 mb-4 mt-md-0">Choose a Fundraiser</h3>
                <p className="">You might already have a cause that you’re passionate about or a personal fundraising goal to achieve. If you’re ready to make a difference but haven’t decided where to start, we’ve put together a list of fundraising ideas for causes we know Australians are passionate about.</p>
                <p className="">Fundraise for someone you know – is someone struggling to raise funds for a personal endeavour, medical bills, education costs, wedding or travel?</p>
                <p className="">Fundraise for the community – local schools, clubs and community events are always in need of additional funds to bring the community together.</p>
                <p className="">Fundraise for a charity – take a look at our charity partners and be inspired by the great work that they do.</p>
              </div>
              <div className='col-lg-4 col-md-5 trending-causes'>
                <div className="card"> <img src={cover} className="img-fluid" alt="" />
                  <div className="text-card"> <span>{formattedAddress}</span> <span>{daysGone}</span> </div>
                  <h1>{title || 'N/A'}</h1>
                  <p>{story || 'N/A'}</p>
                  <div className="text-card m-0"> <span>Last donation</span> <span>{end_date ? moment(end_date).fromNow() : ''}</span> </div>
                  <div className="progres">
                    <div className="progress-inner">
                      <div className="progress-bar" role="progressbar" style={{ width: `${progress || 0}%` }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <div className="treanding-cause-bottom">
                      <h4 className="left-text-s">${amount || 0}<span className="">raised</span></h4>
                      <h4 className="left-right-s">{progress || 0}%</h4> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="past-year">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-10 col-sm-12 mx-auto text-center">
                <h3 className="main-heading mt-4 mb-4 mt-md-0">Our Achievement Past year</h3>
                <p>The CharityPress community was named a “Top 25 Best Global Philanthropist” by Barron’s. We beat Oprah. And, Mashable named CharityPress something like “the best place to raise money online for your favorite causes.”</p>
                <h5>Our strategic priorities up to 2019 are:</h5>
                <div className="price-wraper">
                  <div className="left">
                    <h5 className="text-gren">250,000+</h5>
                    <p>Medical campaign per year</p>
                  </div>
                  <div className="right">
                    <h5 className="text-gren">$50,000</h5>
                    <p>Raised per year</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AllCategoriesSection
          data={categories}
        />

        <FeaturedCampaigns
          data={data}
          loading={loading}
        />

        <WebsiteBenefits />

        <CustomerReviews
          data={customerReviews}
          loading={loading}
        />
      </Spin>
    </div>
  );
};

export default CategoryListings;
